export default function thing() {
	const parent = document.querySelector('.cap-articles')

	if (parent) {
		const lists = parent.querySelectorAll('ul.fndry-list')

		lists.forEach((ul) => {
			const items = ul.querySelectorAll('li.fndry-list-item')

			if (items.length > 3) {
				for (let i = 3; i < items.length; i++) {
					items[i].classList.add('hidden')
				}

				const btn = document.createElement('button')
				btn.innerText = 'VIEW MORE'
				btn.classList.add('fndry-btn', 'viewMore')

				btn.addEventListener('click', function (event) {
					event.stopPropagation()

					if (btn.innerText === 'VIEW MORE') {
						items.forEach((item) => item.classList.remove('hidden'))
						btn.innerText = 'VIEW LESS'
					} else {
						for (let i = 3; i < items.length; i++) {
							items[i].classList.add('hidden')
						}
						btn.innerText = 'VIEW MORE'
					}
				})

				ul.appendChild(btn)
			}
		})
	}
}
